module.exports = __webpack_public_path__ + "img/3.-季节观赏法-秋季-四桥子村大神树（杨树田-摄）.3a355280.jpg";